import { Heading, Stack, Text } from '@global-ecom/nitro-uds/elements';
import BlockContent from '@sanity/block-content-to-react';

import { useSiteConfig } from 'hooks/useSiteConfig';
import {
  ITranslationSupportHTMLTags,
  useTranslate,
} from 'hooks/useTranslations';
import { Prose } from 'utils/serializeBlockContent';

type ShippingReturnsDetailsProps = {
  freeShippingThreshold?: number | null;
  shippingAndReturnContent?: BlockContent[];
  callout?: BlockContent[];
};

export type PDPCalloutContent = { pdpCallout: any[] };

export const ShippingReturnsDetails = (props: ShippingReturnsDetailsProps) => {
  const translate = useTranslate();
  const { currency } = useSiteConfig();

  const callout = props.callout;
  const freeShippingThreshold = props.freeShippingThreshold;

  return (
    <Stack gap="sm">
      <Heading asChild size="sm" weight="bold">
        <h2>{translate('shippingAndReturns')}</h2>
      </Heading>
      {callout ? (
        <Prose content={callout} />
      ) : freeShippingThreshold ? (
        <Text size="base" asChild>
          <p>
            {translate<'freeStandardShipping', ITranslationSupportHTMLTags>(
              'freeStandardShipping',
              {
                days: 30,
                threshold: freeShippingThreshold,
                currency: currency.symbol,
              },
              {
                supportHTMLTags: true,
              }
            )}
          </p>
        </Text>
      ) : null}
    </Stack>
  );
};
